import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import CommissionConfigsIndex from "./CommissionConfigsIndex";
import CommissionConfig from "./CommissionConfig";
import CommissionConfigAssignment from "./CommissionConfigAssignment";

interface IProps extends RouteComponentProps<{}> {
  org: IOrganization;
}

interface IState {}

class CommissionConfigsContainer extends React.Component<IProps, IState> {
  state: Readonly<IState> = {};

  render() {
    const { match, org } = this.props;
    return (
      <>
        <Route
          path={`${match.path}`}
          exact={true}
          render={({ ...props }) => (
            <CommissionConfigsIndex org={org} {...props} />
          )}
        />
        <Route
          path={`${match.path}/config/:configId`}
          component={CommissionConfig}
        />
        <Route
          path={`${match.path}/employees`}
          render={() => <CommissionConfigAssignment org={org} />}
        />
      </>
    );
  }
}

export default CommissionConfigsContainer;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionConfigsContainer.tsx